import "url-polyfill"
import request from "@/utils/request"

export default () => {
  let endpoint = "/api/mickey_mouse/setup"

  if (location.host === "try.blinkist.com") {
    endpoint = "https://www.blinkist.com/api/mickey_mouse/setup"
  }

  return request.get(endpoint, { params: getParams() }).then((config) => {
    if (config) {
      return config
    } else {
      throw new Error("No config data found in Mickey Mouse response")
    }
  })
}

const getParamsFromPageUrl = () => {
  const url = new URL(window.location.href)
  url.searchParams.delete("token") // do not include token params in these tracking calls for security
  const params = {
    url: window.location.href
  }

  if (document.referrer) {
    params.referrer_url = document.referrer // eslint-disable-line camelcase
  }

  url.searchParams.forEach((value, key) => {
    params[key] = value
  })
  return params
}

const getReferrerUrl = () => {
  if (typeof document.referrer !== "undefined" && document.referrer.length > 0) {
    // eslint-disable-next-line camelcase
    return { referrer_url: document.referrer }
  } else {
    return {}
  }
}

const getLocale = () => {
  let langTag = document.querySelector("meta[http-equiv='language']")
  if (langTag) {
    return { locale: langTag.getAttribute("content") }
  } else {
    return {}
  }
}

const getParams = () => {
  return {
    ...getParamsFromPageUrl(),
    ...getReferrerUrl(),
    ...getLocale()
  }
}
